// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackAddWishListToCartParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackAddWishListToCart";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackAddWishListToCart = (
    parameters: PartialSpecific<TrackAddWishListToCartParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.addWishListToCart, parameters, options);
};

export default useTrackAddWishListToCart;
